import { render, staticRenderFns } from "./StatsKpiFilter.vue?vue&type=template&id=379c5a52&scoped=true&"
import script from "./StatsKpiFilter.vue?vue&type=script&lang=js&"
export * from "./StatsKpiFilter.vue?vue&type=script&lang=js&"
import style0 from "./StatsKpiFilter.vue?vue&type=style&index=0&id=379c5a52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379c5a52",
  null
  
)

export default component.exports